import { Container, IconButton } from "@mui/material";
import PageHeader from "components/Shared/PageHeader";
import ContainedTabs, { ContainedTabsProps } from "components/Tabs/Tabs3";
import AddBtn from "./comps/AddBtn";
import DestinationCard from "./comps/DestinationCard";
import useTransaction from "./data";
import SourceCard from "./comps/SourceCard";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import SwitchableTextInput from "components/BasicInputs/SwitchableTextInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { useDispatch, useSelector } from "react-redux";
import { apiGetProjects } from "api/projectApi";
import { apiGetBranches } from "api/branchApi";
import HashtagIcon from "assets/icons/Hashtag";
import BasicButton from "components/BasicInputs/BasicButton";
import shortid from "shortid";
import { appSetAlert } from "store/actions/appAction";
import { formatPrice } from "helpers";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { Close, InfoOutlined } from "@mui/icons-material";
import TransactionInstallmentForm from "./TransactionInstallmentForm";
import PrinterIcon from "assets/icons/PrinterIcon";
import PrintCheque from "components/Shared/Drawer/printCheque";

export interface TransactionContextProps {
  tabs: ContainedTabsProps;
  handleSubmit: (type: number) => void;
  active: any;
  state: any;
  sources: any[];
  setSources: React.Dispatch<React.SetStateAction<any[]>>;
  destinations: any[];
  setDestinations: React.Dispatch<React.SetStateAction<any[]>>;
}

export interface TransactionFormProps {
}

export default function TransactionForm(props: TransactionFormProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const store = useSelector((state: any) => state);
  const token = store.businessReducer.business.token;
  const sendingReq = store.appReducer.sendingRequest;
  const projects = store.projectReducer?.projects?.map((x: any) => ({ ...x, ind: x.id }));
  const branches = store.branchReducer?.branches?.map((x: any) => ({ ...x, ind: x.id }));
  const data = useTransaction();
  const { tabs, handleSubmit, active, state } = data;
  const currency = state.currency;
  const totalPrice = data.sources?.map((x) => x.data?.price || 0)?.reduce((a, b) => a + b);
  const t1 = data.titles[active.tab].payment;
  const t2 = data.titles[active.tab].transaction;
  const t3 = active.tab === 0 ? "دریافت" : "پرداخت";
  const t4 = active.tab === 0 ? "درآمد" : "هزینه";
  const ss = data.sources.filter((x) => x.done).map((x) => x.data?.price || 0);
  const sSum = ss.length > 0 ? ss.reduce((a, b) => a + b) : 0;
  const ds = data.destinations.filter((x) => x.done).map((x) => x.data?.price || 0);
  const dSum = ds.length > 0 ? ds.reduce((a, b) => a + b) : 0;
  const [showAlert, setShowAlert] = useState(true);
  return (
    <Container maxWidth="xl" className="md:pr-12 md:pl-12">
      <div className="mt-5 mb-10">
        <PageHeader
          heading={active.edit ? "ویرایش تراکنش مالی" : "ثبت تراکنش مالی"}
          backBtnTitle="بازگشت به لیست تراکنش ها"
          backAction={() => navigate("/transactions")}
        />
      </div>

      {/* white section */}
      <div className="bg-white rounded-md mb-14">
        {/* tabs */}
        <div className="flex justify-between p-3 border-b border-gray-200 md:px-14">
          {!active.edit ? <ContainedTabs {...tabs} /> : <div></div>}

          <div className="flex items-center gap-2">
            <span className="text-dark-3">واحد پول:</span>
            <BasicSelect
              preferences={{ button: 2 }}
              options={data.currencies}
              noVirtual
              menuStyle={{ minWidth: 200 }}
              onChange={(_, option) => {
                data.setState((x) => ({ ...x, currency: option }));
              }}
            />
          </div>
        </div>

        {/* section one */}
        <div className="flex flex-wrap gap-20 pt-8 lg:flex-nowrap pb-14">
          <div className="flex justify-center w-full p-2">
            <div className="max-w-[420px] w-full">
              <div className="flex items-center justify-between mb-8">
                <div>{t1}</div>
                {data.showInstallmentItem ? (
                  <AddBtn
                    onClick={() => {
                      if (data.sources.find((s) => !s.done)) {
                        dispatch(appSetAlert(`ابتدا ${t3} موجود را تکمیل کنید`, "warning"));
                        return;
                      }
                      data.setSources((s) => [...s, { ind: shortid.generate(), edit: true }]);
                    }}
                  />
                ) : (
                  <div className="min-w-[32px] min-h-[32px]" />
                )}
              </div>
              {data.showInstallmentItem && showAlert && (
                <div className="bg-[#E8F0FF] flex items-center justify-between py-3 px-4 rounded-md my-2">
                  <div className="flex items-center gap-4">
                    <span>
                      <InfoOutlined color="primary" />
                    </span>
                    <span className="text-xs">
                      برای ثبت {t4}، نوع {t3} را به حساب {t4} ها تغییر دهید
                    </span>
                  </div>
                  <IconButton onClick={() => setShowAlert(false)} size="small">
                    <Close fontSize="small" />
                  </IconButton>
                </div>
              )}
              {data.showInstallmentItem ? (
                <div className="flex flex-col gap-4">
                  {data.sources?.map((source, i, a) => {
                    let edit = source.edit;
                    const forceType = i > 0 ? a[0]?.type : undefined;
                    return (
                      <SourceCard
                        key={i}
                        tab={active.tab}
                        currency={currency}
                        edit={edit}
                        forceType={forceType}
                        data={source.data}
                        type={source.type}
                        index={i}
                        onChange={(res) => {
                          data.setSources((s) => s.map((x) => (x.ind === source.ind ? { ...x, ...res } : x)));
                        }}
                        onDelete={(index) => {
                          if (data.sources.length <= 1) {
                            dispatch(appSetAlert(`حداقل یک ${t3} باید وجود داشته باشد`, "warning"));
                            return;
                          }
                          data.setSources((s) => s.filter((_, j) => index !== j));
                        }}
                        onChangeEdit={(edit) => {
                          data.setSources((s) => {
                            return s.map((x, j) => {
                              return i === j ? { ...x, edit } : { ...x, ...(!!edit && { edit: false }) };
                            });
                          });
                        }}
                      />
                    );
                  })}
                </div>
              ) : (
                <div className="flex flex-col gap-4">
                  {
                    data.sources?.map((source, i, a) => {
                      return (
                        <div key={i} className="flex flex-col gap-4">
                          <TransactionInstallmentForm
                            data={data.installmentInitialData}
                            jsonData={data.formikInstallmentInitialData}
                            installmentItem={data?.installmentInitialData?.Installment_Items ?? []}
                            id={data.id}
                            onChange={(res) => {
                              data.setSources((s) => s.map((x) => (x.ind === source.ind ? { ...x, data: { ...data, price: res } } : x)));
                            }}
                          />
                        </div>
                      );
                    })
                  }
                </div>
              )
              }
            </div>
          </div>
          <div className="flex justify-center w-full p-2">
            <div className="max-w-[420px] w-full">
              <div className="flex items-center justify-between mb-8">
                <div>{t2}</div>
                <AddBtn
                  onClick={() => {
                    if (data.destinations.find((d) => !d.done)) {
                      dispatch(appSetAlert(`ابتدا ${t2} موجود را تکمیل کنید`, "warning"));
                      return;
                    }
                    data.setDestinations((d) => [...d, { ind: shortid.generate(), edit: true }]);
                  }}
                />
              </div>
              <div className="flex flex-col gap-4">
                {data.destinations?.map((destination, i, a) => {
                  const chequeShow = destination.typeOption
                  let edit = destination.edit;
                  return (
                    <DestinationCard
                      key={i}
                      currency={currency}
                      edit={edit}
                      data={destination.data}
                      type={destination.type}
                      defPrice={destination.data?.price || totalPrice}
                      totalPrice={totalPrice}
                      transactionType={active.tab === 0 ? "receive" : "payment"}
                      installmentOption={!data.showInstallmentItem}
                      activeOption={data.activeOption}
                      index={i}
                      extraFooterBtn={
                        <>

                          {
                            destination.type === "cheque" && active.edit && chequeShow.dueDate && chequeShow.amount &&
                            <PrintCheque Btn={
                              <BasicButton color="disabled"
                                className="justify-start mr-1">
                                <PrinterIcon color="#6B7888" />
                                <span>چاپ چک</span>
                              </BasicButton>
                            } cheque={{
                              amount: chequeShow.amount, dueDate: chequeShow.dueDate, id: chequeShow.id,
                              inCash: chequeShow.payTo,
                              nationalId: chequeShow.type === "payment" ? chequeShow.received?.nationalId : ""
                            }} />
                          }
                        </>
                      }
                      onChange={(res) => {
                        data.setDestinations((d) =>
                          d.map((x) => (x.ind === destination.ind ? { ...x, ...res } : x))
                        );
                      }}
                      onDelete={(index) => {
                        if (data.destinations.length <= 1) {
                          dispatch(appSetAlert(`حداقل یک ${t2} باید وجود داشته باشد`, "warning"));
                          return;
                        }
                        data.setDestinations((d) => d.filter((_, j) => index !== j));
                      }}
                      onChangeEdit={(edit) => {
                        data.setDestinations((d) => {
                          return d.map((x, j) => {
                            return i === j ? { ...x, edit } : { ...x, ...(!!edit && { edit: false }) };
                          });
                        });
                      }}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* section two */}
        <div className="flex flex-wrap gap-20 lg:flex-nowrap">
          <div className="flex justify-center w-full p-2">
            <div className="max-w-[420px] w-full">
              <div className="flex items-center justify-between mb-8">
                <div>اطلاعات سند تراکنش</div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="flex items-center gap-4">
                  <BasicDateInput
                    label="تاریخ"
                    defaultValues={data.state.date ? [data.state.date] : undefined}
                    styles={{ container: { minWidth: 120, width: 120 } }}
                    withoutClear
                    onChange={(dates) => {
                      if (dates) {
                        data.setState((x: any) => ({ ...x, date: dates[0] }));
                      }
                    }}
                  />
                  <div className="w-full">
                    <SwitchableTextInput
                      label="کد حسابداری"
                      val={data.state.accountingCode}
                      onChange={(val) => data.setState((x: any) => ({ ...x, accountingCode: val }))}
                    />
                  </div>
                </div>
                <BasicTextInput
                  label="شرح"
                  textArea
                  val={data.state.description}
                  onChange={(val) => data.setState((x: any) => ({ ...x, description: val }))}
                />
                <div className="flex items-center gap-4">
                  <div className="w-full">
                    <BasicSelect
                      label="پروژه"
                      options={projects}
                      withRefresh
                      // @ts-ignore
                      refreshList={() => dispatch(apiGetProjects(token))}
                      defaultValue={data.state.projectId}
                      onChange={(projectId, project) =>
                        data.setState((x: any) => ({ ...x, projectId, project }))
                      }
                    />
                  </div>
                  <div className="w-full">
                    <BasicSelect
                      label="شعبه"
                      options={branches}
                      withRefresh
                      // @ts-ignore
                      refreshList={() => dispatch(apiGetBranches(token))}
                      defaultValue={data.state.branchId}
                      onChange={(branchId, branch) =>
                        data.setState((x: any) => ({
                          ...x,
                          branchId,
                          branch
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-center w-full p-2">
            {false && (
              <div className="max-w-[420px] w-full">
                <div
                  className="min-w-[200px] min-h-[300px] p-4 pb-0 rounded-md relative shadow-[0_0_20px_0px_rgba(0,0,0,0.2)]">
                  <div className="w-full h-px border-custom-dashed" />

                  {/* info */}
                  <div className="flex flex-col gap-4">
                    <div className="flex items-center justify-between py-4">
                      <div className="flex items-center gap-2">
                        <div className="flex items-center justify-center w-6 h-6 border rounded-full border-slate-300">
                          <HashtagIcon />
                        </div>
                        {state.accountingCode ? (
                          <div className="text-xl text-blue-1">{state.accountingCode}</div>
                        ) : (
                          <div className="text-blue-1">اتوماتیک</div>
                        )}
                      </div>
                      <div className="text-base text-dark-3">{state.date}</div>
                    </div>
                    {!!totalPrice && (
                      <div className="flex flex-col items-center justify-center">
                        <div className="text-base">رسید دریافت</div>
                        <div className="flex items-center gap-2">
                          <span className="text-[28px] text-dark-1">{formatPrice(totalPrice)}</span>
                          <span className="text-[20px] text-dark-3">{currency?.en_title}</span>
                        </div>
                      </div>
                    )}
                    <div className="flex flex-col gap-4 p-4">
                      {state.project && (
                        <div className="flex items-center justify-between">
                          <div className="text-dark-3">پروژه:</div>
                          <div className="">{state?.project?.title}</div>
                        </div>
                      )}
                      {state.branch && (
                        <div className="flex items-center justify-between">
                          <div className="text-dark-3">شعبه:</div>
                          <div className="">{state?.branch?.title}</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="w-full h-px border-custom-dashed" />

                  {/* items */}
                  <div className="flex flex-col gap-4 py-4">
                    {data.sources.map((source, index) =>
                      source.done ? (
                        <SourceCard
                          key={index}
                          justShow
                          data={source.data}
                          tab={active.tab}
                          currency={currency}
                        />
                      ) : (
                        <></>
                      )
                    )}
                    {data.destinations.map((dest, index) =>
                      dest.done ? (
                        <DestinationCard
                          key={index}
                          justShow
                          data={dest.data}
                          tab={active.tab}
                          currency={currency}
                          activeOption={[]}
                        />
                      ) : (
                        <></>
                      )
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="flex bg-white p-4 rounded-md gap-4 justify-between sticky bottom-0 items-center z-[2] shadow-inner flex-wrap md:flex-nowrap">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 pl-4 border-l border-gray-300">
            <span className="">{active.tab === 0 ? "مجموع دریافت:" : "مجموع پرداخت:"}</span>
            <div className="flex items-center gap-2">
              <span className="text-[25px]" dir="ltr">
                {formatPrice(sSum)}
              </span>
              <span className="text-dark-3">{currency?.en_title}</span>
            </div>
          </div>
          {sSum !== dSum && (
            <div className="flex items-center gap-2">
              <span className={`${dSum !== sSum ? "text-red-500" : "text-green-500"}`}>باقی مانده:</span>
              <div className="flex items-center gap-2">
                <span className="text-[25px]" dir="ltr">
                  {formatPrice(sSum - dSum)}
                </span>
                <span className="text-dark-3">{currency?.en_title}</span>
              </div>
            </div>
          )}
        </div>
        {active.edit ? (
          <BasicButton
            disabled={sendingReq || dSum !== sSum || !dSum || !sSum}
            variant="contained"
            className="w-36 md:w-48"
            onClick={() => handleSubmit()}
          >
            ذخیره تراکنش
          </BasicButton>
        ) : (
          <BasicButton
            disabled={sendingReq || dSum !== sSum || !dSum || !sSum}
            variant="contained"
            className="w-36 md:w-48"
            onClick={() => handleSubmit()}
          >
            ثبت تراکنش
          </BasicButton>
        )}
      </div>
    </Container>
  );
}
